import moment from "moment";
import { USE_IMAGE_PLACEHOLDERS } from "./constants/paths";

import * as CryptoJS from 'crypto-js';
import appConfig from "app/config/appConfig";

export const getAssetPath = (url, size) => {
  if (USE_IMAGE_PLACEHOLDERS) {
    return `https://via.placeholder.com/${size}.png`;
  }

  return url;
};

export const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
}

export const formatNpwpNumber = (str) => {
  if (!str) return ''
  return str.replace(/[^\w\s]/gi, '')
}

export const convertDate = (d, f = 'DD MMM YYYY') => {
  let date = moment(d);
  return date.format(f);
}

export function formatString(str) {
  if (str.length !== 15) {
    return "";
  }

  const part1 = str.slice(0, 2);
  const part2 = str.slice(2, 5);
  const part3 = str.slice(5, 8);
  const part4 = str.slice(8, 9);
  const part5 = str.slice(9, 12);
  const part6 = str.slice(12, 15);

  return `${part1}.${part2}.${part3}.${part4}-${part5}.${part6}`;
}

export function encryptPayload(data) {
    const dataEncryption = CryptoJS.AES.encrypt(
        JSON.stringify(data),
        appConfig.AES_SK
    ).toString();
    return dataEncryption;
};


export const ERROR_SERVER_DEFAULT = "Oops.. Somethings is wrong. Please try again later.";

export function decryptData(encryptString) {
  try {
    var base64EncodedKeyFromJava = 'QUJDREVGR0hJSktMTU5PUA==';
    var keyForCryptoJS = CryptoJS.enc.Base64.parse(base64EncodedKeyFromJava);

    var decodeBase64 = CryptoJS.enc.Base64.parse(encryptString)

    var decryptedData = CryptoJS.AES.decrypt({
      ciphertext: decodeBase64
    },
      keyForCryptoJS, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }
    );

    var decryptedText = decryptedData.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedText)
  } catch (error) {
    return null;
  }
}